import {
  HISTORY_OPEN_EDIT,
  HISTORY_OPEN_FORK,
  HISTORY_OPEN_VIEW,
} from '@/constants/historyOpenModes';

export const OPEN_INTENT_VERSION = 1;

const HISTORY_MODES = new Set([HISTORY_OPEN_VIEW, HISTORY_OPEN_FORK, HISTORY_OPEN_EDIT]);

function normalizeMode(value) {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function normalizeSource(value) {
  if (value === 'course' || value === 'history') return value;
  return null;
}

function normalizeHistoryMode(value) {
  return HISTORY_MODES.has(value) ? value : null;
}

export function normalizeOpenIntent(rawIntent) {
  if (!rawIntent || typeof rawIntent !== 'object') return null;
  const source = normalizeSource(rawIntent.source);
  const calculationModuleId = normalizeMode(rawIntent.calculationModuleId);
  if (!source || !calculationModuleId) return null;

  const historyOpenMode = normalizeHistoryMode(rawIntent.historyOpenMode);
  if (source === 'history' && !historyOpenMode) return null;

  const restoredAt =
    typeof rawIntent.restoredAt === 'string' && rawIntent.restoredAt
      ? rawIntent.restoredAt
      : new Date().toISOString();

  return {
    source,
    calculationModuleId,
    courseId: rawIntent.courseId ?? null,
    planId: normalizeMode(rawIntent.planId),
    runId: normalizeMode(rawIntent.runId),
    historyOpenMode: source === 'history' ? historyOpenMode : null,
    sourceRunId: normalizeMode(rawIntent.sourceRunId),
    sourceDisplayName: typeof rawIntent.sourceDisplayName === 'string' ? rawIntent.sourceDisplayName : '',
    sourceCreatedAt: typeof rawIntent.sourceCreatedAt === 'string' ? rawIntent.sourceCreatedAt : '',
    restoredAt,
    version: Number(rawIntent.version) || OPEN_INTENT_VERSION,
  };
}

export function createCourseOpenIntent({ calculationModuleId, courseId = null, planId = null }) {
  return normalizeOpenIntent({
    source: 'course',
    calculationModuleId,
    courseId,
    planId,
    historyOpenMode: null,
    restoredAt: new Date().toISOString(),
    version: OPEN_INTENT_VERSION,
  });
}

export function createHistoryOpenIntent({
  calculationModuleId,
  courseId = null,
  planId = null,
  runId = null,
  historyOpenMode,
  sourceRunId = null,
  sourceDisplayName = '',
  sourceCreatedAt = '',
}) {
  return normalizeOpenIntent({
    source: 'history',
    calculationModuleId,
    courseId,
    planId,
    runId,
    historyOpenMode,
    sourceRunId,
    sourceDisplayName,
    sourceCreatedAt,
    restoredAt: new Date().toISOString(),
    version: OPEN_INTENT_VERSION,
  });
}

/**
 * Backward compatibility bridge from restore payload.
 */
export function intentFromRestorePayload(payload) {
  if (!payload || typeof payload !== 'object') return null;
  const modeId = normalizeMode(payload.mode);
  if (!modeId) return null;
  const historyMode = normalizeHistoryMode(payload.openMode);
  if (!historyMode) {
    return createCourseOpenIntent({
      calculationModuleId: modeId,
      planId: payload.plan_id || null,
    });
  }
  return createHistoryOpenIntent({
    calculationModuleId: modeId,
    planId: payload.plan_id || null,
    runId: payload.run_id || null,
    historyOpenMode: historyMode,
    sourceRunId: payload.source_run_id || payload.run_id || null,
    sourceDisplayName: payload.source_display_name || '',
    sourceCreatedAt: payload.source_created_at || '',
  });
}
